module.exports = __webpack_public_path__ + "img/Compliance Automation_solid.08e2f4bc.svg";